export const onError = (payload) => ({ type: 'ERROR', payload: payload });

export const onLocaleChange = (payload) => ({ type: 'LOCALE', payload: payload });
